import { fetchVideoRemakeCreditPreview, getPreviewVideoCredit } from "@apis/http/api";
import type { BodyOf } from "@apis/http/typedRoute";
import type { JobDetailData } from "@apis/api.types";
import {
  buildCreditPreviewIdentity,
  classifyReferenceVideoIdentity,
  type LooseReferenceVideoFields,
} from "@apis/videoRemakeRequest";

type CreationCreditParams = BodyOf<"POST/api/video/creation/credit-preview">;
type RemakeCreditParams = BodyOf<"POST/api/video/remake/credit-preview">;

export async function fetchVideoCreditPreviewByJobDetail(
  jobDetail: Pick<JobDetailData, "jobType" | "input">,
): Promise<number> {
  const { jobType, input } = jobDetail;
  if (!input) return 0;

  if (jobType === "VIDEO_REMAKE") {
    // 任务详情 input 的 TS 类型未声明参考视频字段，但运行时实际带有，转成松散字段交给工厂归一化。
    const identity = classifyReferenceVideoIdentity(input as unknown as LooseReferenceVideoFields);
    if (!identity || !input.resolution) return 0;

    const res = await fetchVideoRemakeCreditPreview({
      ...buildCreditPreviewIdentity(identity),
      resolution: input.resolution as RemakeCreditParams["resolution"],
    });
    return res || 0;
  }

  if (!input.internalModelId) return 0;

  const res = await getPreviewVideoCredit({
    aspectRatio: input.aspectRatio,
    duration: input.duration,
    quantity: input.quantity,
    resolution: input.resolution,
    internalModelId: input.internalModelId,
  } as unknown as CreationCreditParams);
  return res || 0;
}
